import React, {useEffect, useRef, useState} from 'react';
import i18n from 'i18next';
import Button from '@/Components/Button';
import Authenticated from '@/Layouts/Authenticated';
import {Head, Link, useForm, usePage} from '@inertiajs/inertia-react';
import {FormInput, FormRadio} from "@/Components/Controls";
import "../../../sass/guest/add-denomination.scss";

export default function AddDenomination() {

    const [denomOptions, setDenomOptions] = useState([]);

    const [showExample, setShowExample] = useState(true);

    useEffect(() => {
        axios.get(route('organization.add-denomination.fetch'))
            .then(res => {setDenomOptions(res.data)});
    }, [])

    useEffect(() => {
        setShowExample(denomOptions.includes("Other"));
    }, [denomOptions])

    const {data, setData, post, processing, errors} = useForm({
        radio: '',
        example: ''
    });

    function onChange(name, value) {
        if(name === "example") {
            setData({
                radio: "Other",
                example: value,
            });
        } else {
            setData(name, value);
        }
    }

    useEffect(() => {
        //TODO Will need to update Other string for different Languages
        if(data.radio !== "Other") {
            setData("denomination", data.radio);
        } else {
            setData("denomination", data.example);
        }
    }, [data.radio, data.example])

    const submit = (e) => {
        e.preventDefault();

        post(route('organization.add-denomination.store'));
    };

    return (
        <Authenticated className="extra-spacing" hideTopBar={true}>
            <Head title="Add Denomination"/>
            <div className="outside-logo"></div>
            <div className="add-denomination">
                <form onSubmit={submit}>
                    <div data-testid="add_denomination-div-title" className="title">{i18n.t("add-denomination.describes")}?</div>
                    <div className="row">
                        <FormRadio
                            error={errors["radio"]}
                            name="radio"
                            onChange={onChange}
                            value={data.radio}
                            options={denomOptions}
                            className="col-12 small"
                            dataTestid="add_denomination-radio_list"/>
                    </div>
                    <div className="row example-container">
                        { showExample &&
                            <FormInput
                                error={errors["denomination"]}
                                name="example"
                                value={data.example}
                                onChange={onChange}
                                placeholder={i18n.t("add-denomination.example")}
                                className="col-12 example"
                                dataTestid="add_denomination-input-example"
                            />
                        }
                    </div>

                    <div className="">
                        <Button dataTestid="add_denomination-button-submit" className="w-100 btn btn-primary" processing={processing || (!data.radio && !data.example)}>
                            <span>{i18n.t("add-denomination.continue")}</span><i className="far fa-chevron-right"></i>
                        </Button>
                    </div>
                </form>
            </div>
            <div className="step">
                <Link href={route('organization.add-attendance.show')} className="no-link">
                    <i className="fal fa-long-arrow-left"></i>
                </Link>
                <span>{i18n.t("add-denomination.step")} 4 {i18n.t("add-denomination.of")} 5</span>
            </div>
        </Authenticated>
    );
}
